export const ICONS = {
	LOGO : '#logo',
	CHEVRON_LEFT : '#chevron-left',
	CHEVRON_RIGHT: '#chevron-right',
	COPY: '#copy',
};


// WEBPACK FOOTER //
// ./src/icons/Icons.js